var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "check-exam-status" }, [
    _c(
      "div",
      { staticClass: "exam-header" },
      [
        _c(
          "el-row",
          { attrs: { type: "flex", justify: "space-between" } },
          [
            _c(
              "el-col",
              { staticClass: "exam-title", attrs: { span: 8 } },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "light",
                      content: _vm.trainingInfo.trainingName,
                      placement: "right",
                    },
                  },
                  [_c("h3", [_vm._v(_vm._s(_vm.trainingInfo.trainingName))])]
                ),
              ],
              1
            ),
            _c("el-col", { attrs: { span: 8 } }, [
              !_vm.isDingding
                ? _c("div", { staticClass: "goback" }, [
                    _c("i", {
                      staticClass: "iconfont icon-guanbi2",
                      attrs: { title: "关闭" },
                      on: { click: _vm.closePage },
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "closeitem",
                        on: { click: _vm.closePage },
                      },
                      [_vm._v("关闭")]
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "exam-main" }, [
      _c("div", { staticClass: "result-wrapper" }, [
        _c(
          "div",
          { staticClass: "status-info" },
          [
            _c("div", { staticClass: "exam-user" }, [
              _c(
                "div",
                { staticClass: "exam-user-photo" },
                [
                  _vm.trainingInfo.userId
                    ? _c("el-avatar", {
                        attrs: {
                          size: 100,
                          src:
                            "/oua2/getUserPhoto?type=relativePath&userId=" +
                            _vm.trainingInfo.userId,
                        },
                        on: { error: _vm.errorHandler },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "exam-user-name" }, [
                _c("span", [_vm._v(_vm._s(_vm.trainingInfo.userName))]),
              ]),
            ]),
            _c(
              "el-tooltip",
              {
                staticClass: "item",
                attrs: {
                  effect: "light",
                  content: _vm.trainingInfo.trainingName,
                  placement: "top",
                },
              },
              [
                _c("div", { staticClass: "exam-title" }, [
                  _c("p", [_vm._v(_vm._s(_vm.trainingInfo.trainingName))]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "table-content" },
              [
                _c(
                  "el-table",
                  {
                    ref: "singleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      "max-height": "350",
                      data: _vm.trainingInfo.presentRecordDtoList,
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "次数", width: "80", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" 第" + _vm._s(scope.row.times) + "次 "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "状态", width: "90", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.status))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        property: "rightRate",
                        label: "正确率",
                        width: "90",
                        "show-overflow-tooltip": true,
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        property: "useTime",
                        label: "用时",
                        width: "180",
                        "show-overflow-tooltip": true,
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { width: "100", label: "操作", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status === "进行中" &&
                              _vm.isCurrent === true
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.continueExam(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 继续练习 ")]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.checkDetails(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 查看详情 ")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "exam-button-bar" }, [
          _vm.trainingInfo.status !== "历史" && _vm.isCurrent === false
            ? _c(
                "div",
                {
                  staticClass: "exam-button-item",
                  on: { click: _vm.tryAgain },
                },
                [_c("span", [_vm._v("开始练习")])]
              )
            : _vm.trainingInfo.status !== "历史" && _vm.isCurrent === true
            ? _c(
                "div",
                {
                  staticClass: "exam-button-item",
                  on: { click: _vm.continueExam },
                },
                [_vm._v("继续练习")]
              )
            : !_vm.isDingding
            ? _c(
                "div",
                {
                  staticClass: "exam-button-item",
                  on: { click: _vm.closePage },
                },
                [_vm._v("关闭")]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }